require('./bootstrap');

require('alpinejs');


let Pikaday = require ('pikaday');
window.Pikaday = Pikaday;
